import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = ({ board }) => board;

const makeSelectBoardList = () => createSelector(
  store,
  ({ boardList }) => boardList,
);

const makeSelectBoardListTotal = () => createSelector(
  store,
  ({ total }) => total,
);

const makeSelectBoardListPagination = () => createSelector(
  store,
  ({
    size,
    page,
    orders,
    filters,
  }) => ({
    size,
    page,
    orders,
    filters,
  }),
);

export {
  makeSelectBoardList,
  makeSelectBoardListTotal,
  makeSelectBoardListPagination,
};
